module.exports = __webpack_public_path__ + "static/media/zombie.78374639.png";